import {
  StatsManfreditesQueryRequest,
  StatsManfreditesResponse
} from '@asgard/api-common';
import { ManfreditesStats } from 'model/manfredites-stats/model.manfredites-stats';
import { getApiPathUrl } from 'utils/api';
import * as fetch from 'utils/fetch';
import { getAuthHeader } from 'utils/headers';
import { normalizeToManfrediteStats } from './service.manfredite-stats.normalizer';

export const ServiceManfreditesStats = {
  get: async (req: StatsManfreditesQueryRequest): Promise<ManfreditesStats> => {
    const url = getApiPathUrl('/v2/public/stats/manfredites');

    const params = new URLSearchParams();

    params.append('roleId', req.roleId.toString());
    params.append('withFluentEnglish', req.withFluentEnglish.toString());

    if (req.techIds) {
      params.append('techIds', req.techIds.join(','));
    }

    if (req.location) {
      params.append('location', req.location?.toString() || '');
    }

    const res = await fetch.get<StatsManfreditesResponse>(
      `${url}?${params}`,
      getAuthHeader()
    );

    return normalizeToManfrediteStats(res);
  }
};
